// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2UqbK","label":"Labeled_label__24woM","divider":"Labeled_divider__2ykdq"};